var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2269 1.54201C10.672 0.597975 9.33182 0.597975 8.77697 1.54201L0.205782 16.1253C-0.365509 17.0974 0.320348 18.334 1.43074 18.334H18.5731C19.6835 18.334 20.3694 17.0974 19.7981 16.1253L11.2269 1.54201ZM10 5.83398C10.6693 5.83398 11.1922 6.41184 11.1256 7.07778L10.6872 11.4621C10.6519 11.8151 10.3548 12.084 10 12.084C9.64519 12.084 9.34811 11.8151 9.31281 11.4621L8.87438 7.07778C8.80779 6.41184 9.33074 5.83398 10 5.83398ZM10.0019 13.334C10.6923 13.334 11.2519 13.8936 11.2519 14.584C11.2519 15.2743 10.6923 15.834 10.0019 15.834C9.31157 15.834 8.75193 15.2743 8.75193 14.584C8.75193 13.8936 9.31157 13.334 10.0019 13.334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportError);
export default __webpack_public_path__ + "static/media/import_error.3e9cd20630c731f1238dc41f10e1c303.svg";
export { ForwardRef as ReactComponent };